import Icon from 'veui/components/Icon'
import { IconTrendDesktop } from 'dls-icons-vue'

Icon.register('trend-desktop', IconTrendDesktop)
